export default __webpack_public_path__ + "static/car-piece-1-1faf4c70b9291358233fc53a7f343bd7.jpg";